<header class="health-first-wrapper" [hidden]="util.isMobile() && hideHeader">
  <div [ngClass]="{'container': !util.isMobile(), 'mob-container': util.isMobile()}">
    <div class="header-content">
      <div class="img-wrapper">
        <a routerLink="/healthfirst">
          <img src="/assets/images/health-first/health-first-logo.svg">
        </a>
      </div>
      <div class="content">
        <app-button *ngIf="isLoggedIn && !isThankyouPage && !isPlans" btnClass="hf-primary-btn hf-header-btn" (btnClick)="onPlanClick()" label="Our Plans"></app-button>
        <app-button *ngIf="!isLoggedIn" btnClass="hf-primary-btn hf-header-btn login" label="Login" (btnClick)="onLoginClick()"></app-button>
      </div>
    </div>
  </div>
</header>